import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Text,
  SafeAreaView,
  StyleSheet, View,
} from "react-native";
import { howtoTrade } from "../home.constant";
import { globalFontStyle } from "../../../assets";
import FastImage from "../../../common/FastImage";
import {Carousel} from "react-responsive-carousel";
import Width from "../../../assets/Width";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";
import width from "../../../assets/Width";

const HowtoTradeModal = ({}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const prev = () => {
    setCurrentSlide(currentSlide - 1);
  };

  const updateCurrentSlide = (index) => {
    if (currentSlide !== index) {
      setCurrentSlide(index);
    }
  };
  // function pagination() {
  //   return (
  //     <Pagination
  //       dotsLength={howtoTrade?.length || 0}
  //       activeDotIndex={activeSlide}
  //       containerStyle={{
  //         backgroundColor: "rgba(0, 0, 0, 0.0)",
  //       }}
  //       dotStyle={{
  //         width: 7,
  //         height: 7,
  //         borderRadius: 5,
  //         marginVertical: 0,
  //         backgroundColor: Colors.tradexBlue,
  //       }}
  //       inactiveDotStyle={{
  //         width: 10,
  //         height: 10,
  //         borderRadius: 5,
  //         backgroundColor: "#DEDEDE",
  //       }}
  //       inactiveDotOpacity={1}
  //       inactiveDotScale={0.6}
  //     />
  //   );
  // }

  // function renderItem({ item, index }) {
  //   return (
  //     <TouchableOpacity
  //       activeOpacity={0.8}
  //       key={index}
  //       style={{ borderWidth: 0, padding: 40 }}
  //     >
  //       <Text
  //         style={[globalFontStyle.appFontHeading, { color: Colors.tradexBlue }]}
  //       >
  //         {item?.title}
  //       </Text>
  //       <FastImage
  //         style={{ width: "100%", height: 200 }}
  //         source={item?.imgUrl()}
  //       />
  //       <Text style={[globalFontStyle.appFontSubTextBold, styles.textStyle]}>
  //         {item?.block1}
  //       </Text>
  //       <Text style={[globalFontStyle.appFontSubTextBold, styles.textStyle]}>
  //         {item?.block2}
  //       </Text>
  //       <Text style={[globalFontStyle.appFontSubTextBold, styles.textStyle]}>
  //         {item?.block3}
  //       </Text>
  //       <Text style={[globalFontStyle.appFontSubTextBold, styles.textStyle]}>
  //         {item?.block4}
  //       </Text>
  //     </TouchableOpacity>
  //   );
  // }
  return (
      <SafeAreaView style={{ flex : 1 }}>
        <Carousel
            showThumbs={false}
            swipeable={true}
            emulateTouch={true}
            swipeScrollTolerance={5}
            selectedItem={currentSlide}
            onChange={updateCurrentSlide}
            showArrows={false}
            showIndicators={false}
            showStatus={false}
            autoPlay={false}
            transitionTime={3000}
        >
          {howtoTrade.map((item, index) => {
            return (
                <View
                    key={index}
                    style={{ borderWidth: 0, paddingHorizontal: 0, marginTop: 50, height: width.height }}
                >
                  <Text
                      style={[globalFontStyle.appFontTitle, { color: globalConfigurableData.primaryTextColor1, marginBottom: 30 }]}
                  >
                    {item?.title}
                  </Text>
                  <FastImage
                      style={{ width: Width.width, height: 330 }}
                      source={item?.imgUrl()}
                  />
                  <Text style={[globalFontStyle.appFontEventTitle, styles.textStyle, {color: GlobalScreens.SingleOrder.highlightColor, marginTop: 30 }]}>
                    {item?.block1}
                  </Text>
                  <Text style={[globalFontStyle.appFontBody, styles.textStyle]}>
                    {item?.block2}
                  </Text>
                </View>
            );
          })}
        </Carousel>
        <View style={{
          position: 'absolute',
          bottom: 200,
          width: "100%",
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 10,
        }}>
          {howtoTrade.map((item, index) => {
            return (
                <View
                    key={index}
                    style={{ borderRadius: 100,
                      height: 8,
                      width: 8,
                      backgroundColor: currentSlide === index ?
                          globalConfigurableData.primaryTextColor1
                          : globalConfigurableData.secondaryTextColor1 }}
                >
                </View>
            );
          })}
        </View>
      </SafeAreaView>
  );
};
export default connect(null, null)(HowtoTradeModal);

const styles = StyleSheet.create({
  textStyle: {
    color: globalConfigurableData.primaryTextColor1,
    marginTop: 5,
  },
});
